<div class="flex flex-column h-full pb-4">
  <form [formGroup]="formGroup" class="flex flex-column gap-4 mb-4">
    <div class="flex flex-column gap-2">
      <label for="institution" class="font-medium">Institution <span class="text-red-500">*</span></label>
      <p-select id="institution" aria-describedby="institution-help" formControlName="institutionId" optionValue="id"
                  [editable]="true" filter="true" filterBy="name" [options]="institutions"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('institutionId')}"
                  optionLabel="name" placeholder="Sélectionner une institution"/>
      <small *ngIf="boundData?.isCreate && !hasFieldError('institutionId')" id="institution-help" class="text-gray-600">
        Renseigner ici le nom de l'institution.
      </small>
      <small *ngIf="hasFieldError('institutionId')" class="text-red-500">
        {{ getFieldError('institutionId') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="type" class="font-medium">Type de compte <span class="text-red-500">*</span></label>
      <p-select id="type" aria-describedby="type-help" formControlName="type"
                  [editable]="true" filter="true" filterBy="name" [options]="accountTypes"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('type')}"
                  placeholder="Sélectionner le type de compte"/>
      <small *ngIf="boundData?.isCreate && !hasFieldError('type')" id="type-help" class="text-gray-600">
        Renseigner ici le type de compte.
      </small>
      <small *ngIf="hasFieldError('type')" class="text-red-500">
        {{ getFieldError('type') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="bank" class="font-medium">Banque <span class="text-red-500">*</span></label>
      <p-select id="bank" aria-describedby="bank-help" formControlName="bank"
                  [editable]="true" filter="true" filterBy="name" [options]="banks" optionValue="id"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('bank')}"
                  optionLabel="name" placeholder="Sélectionner une banque"/>
      <small *ngIf="boundData?.isCreate && !hasFieldError('bank')" id="bank-help" class="text-gray-600">
        Renseigner ici le nom de la banque.
      </small>
      <small *ngIf="hasFieldError('bank')" class="text-red-500">
        {{ getFieldError('bank') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="codeAgency" class="font-medium">Code d'agence <span class="text-red-500">*</span></label>
      <input pInputText id="codeAgency" aria-describedby="codeAgency-help" formControlName="codeAgency"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('codeAgency')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('codeAgency')" id="codeAgency-help" class="text-gray-600">
        Code d'agence (3-10 caractères).
      </small>
      <small *ngIf="hasFieldError('codeAgency')" class="text-red-500">
        {{ getFieldError('codeAgency') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="number" class="font-medium">Numéro de compte <span class="text-red-500">*</span></label>
      <input pInputText id="number" aria-describedby="number-help" formControlName="number"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('number')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('number')" id="number-help" class="text-gray-600">
        Numéro de compte (5-34 caractères).
      </small>
      <small *ngIf="hasFieldError('number')" class="text-red-500">
        {{ getFieldError('number') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="libelle" class="font-medium">Libellé <span class="text-red-500">*</span></label>
      <input pInputText id="libelle" aria-describedby="libelle-help" formControlName="libelle"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('libelle')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('libelle')" id="libelle-help" class="text-gray-600">
        Libellé du compte (3-100 caractères).
      </small>
      <small *ngIf="hasFieldError('libelle')" class="text-red-500">
        {{ getFieldError('libelle') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="devise" class="font-medium">Devise <span class="text-red-500">*</span></label>
      <p-select id="devise" aria-describedby="devise-help" formControlName="currency" [editable]="true" filter="true"
                  filterBy="code,description" [options]="devises" optionLabel="description"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('currency')}"
                  optionValue="code" placeholder="Sélectionner une devise" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('currency')" id="devise-help" class="text-gray-600">
        Sélectionner la devise du compte.
      </small>
      <small *ngIf="hasFieldError('currency')" class="text-red-500">
        {{ getFieldError('currency') }}
      </small>
    </div>
      <div class="flex flex-column gap-2">
        <label for="rib" class="font-medium">RIB <span class="text-red-500">*</span></label>
        <input pInputText id="rib" aria-describedby="rib-help" formControlName="rib"
               [ngClass]="{'ng-invalid ng-dirty': hasFieldError('rib')}" />
        <small *ngIf="boundData?.isCreate && !hasFieldError('rib')" id="rib-help" class="text-gray-600">
          RIB (16-24 chiffres uniquement).
        </small>
        <small *ngIf="hasFieldError('rib')" class="text-red-500">
          {{ getFieldError('rib') }}
        </small>
      </div>
      <div class="flex flex-column gap-2">
        <label for="ribKey" class="font-medium">Clé RIB</label>
        <input pInputText id="ribKey" aria-describedby="ribKey-help" formControlName="ribKey"
               [ngClass]="{'ng-invalid ng-dirty': hasFieldError('ribKey')}" />
        <small *ngIf="boundData?.isCreate && !hasFieldError('ribKey')" id="ribKey-help" class="text-gray-600">
          Clé RIB (1-2 chiffres, optionnel).
        </small>
        <small *ngIf="hasFieldError('ribKey')" class="text-red-500">
          {{ getFieldError('ribKey') }}
        </small>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label for="iban" class="font-medium">IBAN <span class="text-red-500">*</span></label>
        <input pInputText id="iban" aria-describedby="iban-help" formControlName="iban"
               [ngClass]="{'ng-invalid ng-dirty': hasFieldError('iban')}"
               placeholder="FR7630001007941234567890185" />
        <small *ngIf="boundData?.isCreate && !hasFieldError('iban')" id="iban-help" class="text-gray-600">
          IBAN (15-34 caractères, format : 2 lettres + 2 chiffres + alphanumériques).
        </small>
        <small *ngIf="hasFieldError('iban')" class="text-red-500">
          {{ getFieldError('iban') }}
        </small>
      </div>
  </form>
  <div class="flex mb-4 gap-2 justify-content-end">
    <p-button pRipple *ngIf="!formGroup.disabled" [style]="{width: '100%'}" class="mb-4"
              [label]=" boundData?.isCreate  ? 'Enregistrer' : 'Modifier'" [disabled]="!formGroup.valid"
              [loading]="isLoading" (onClick)="boundData?.isCreate ? create() : update()"></p-button>
  </div>
</div>

